import * as types from './types'
import storage from '@/Plugins/storage'

export default {
  [types.SET_PAGER](state, data) {
    switch (data.name) {
      case 'orderBy': {
        state.pager.orderBy = data.value
        break
      }
      case 'sortBy': {
        state.pager.sortBy = data.value
        break
      }
      case 'search': {
        state.pager.search = data.value
        break
      }
      case 'page': {
        state.pager.page = data.value
        break
      }
      case 'pageSize': {
        state.pager.pageSize = data.value
        break
      }
    }
    storage.session.setItem(types.STORE_PAGER, JSON.stringify(state.pager))
  },
  [types.SET_CHECKED](state, data) {
    state.isChecked = false
  },
  [types.RESET_BLOBS](state, data) {
    state.blobs = []
  },
  [types.RESET_BLOB](state, data) {
    state.blob = JSON.parse(JSON.stringify(state.defaultBlob))
  },
  [types.SET_BLOBS](state, data) {
    state.blobs = []
    if (data !== undefined && data !== null) {
      state.blobs = data
    }
    console.log('Got Blobs', state.blobs)
  },
  [types.SET_BLOB](state, data) {
    state.blob = null
    if (data !== undefined && data !== null) {
      let found = state.blobs.find((x) => parseInt(x.id) === parseInt(data))
      if (found) {
        state.blob = JSON.parse(JSON.stringify(found))
      }
    }
  },
  [types.SET_BLOB_DATA](state, data) {
    switch (data.name) {
      case 'name': {
        state.blob.name = data.value
        break
      }
      case 'url': {
        if (
          data.value.indexOf('youtube.') === 0 ||
          data.value.indexOf('youtu.be') === 0
        ) {
          state.blob.youtubeUrl = data.value
        } else {
          state.blob.videoUrl = data.value
        }
        break
      }
      case 'orgid': {
        state.blob.orgId = parseInt(data.value)
        break
      }
      case 'isActive': {
        state.blob.archived = data.value
        break
      }
      case 'classId': {
        state.blob.class_id = data.value
        state.blob.classUid = data.value
        break
      }
    }
  },
}
